import React, { useMemo, useRef, useState } from 'react';
import GridSearchTemplate from '../GridSearchTemplate';
import { Availability } from '../../api/services/next';
import { Button, Form } from 'semantic-ui-react';
import { DatePicker } from '../../components/shared/DatePicker';
import { useTextResources } from '../../language';
import HotelsDropDown from '../../components/shared/HotelsDropDown';
import RoomTypesDropDown from '../../components/shared/RoomTypesDropDown';
import moment from 'moment';
import { dateFormat } from '../../components/shared/constants';
import { EditMaxOccupancyPopup } from './EditMaxOccupancyPopup';

const AvailabilityPage = () => {
    const text = useTextResources();
    const [hotelIds, setHotelIds] = useState([]);
    const [edit, setEdit] = useState(false);
    const doSearch = useRef();

    const roomTypeSpec = useMemo(() => {
        return { HotelIds: hotelIds || [ ] }
    }, [hotelIds])

    const hotelFormatter = ({ value }) => {
        return window.user?.ChainHotels?.find(h => h.Id === value)?.Name ?? value;
    }
    const roomtypeFormatter = ({ value, row }) => {
        return row.RoomType?.Name ?? value;
    }
    const dateFormatter = ({ value }) => {
        return value && moment(value).format(dateFormat)
    }
    const occupancyFormatter = ({ row }) => {
        const occupancy = row.Adults + row.Children + row.Infants;
        return <span style={{ color: row.MaxOccupancy && occupancy >= row.MaxOccupancy ? "red" : "" }}>{occupancy}</span>
    }
    const oooFormatter = ({ row }) => {
        return row.Ooo + "/" + row.Oos
    }
    const boldFormatter = (text) => {
        return <b>{text ?? ''}</b>;
    }
    const availableRoomsFormatter = ({ row }) => {
        return boldFormatter(row.Available);
    }
    const maxOccupancyFormatter = ({ row }) => {
        return boldFormatter(row.MaxOccupancy);
    }

    const gridOptions = {
        search: {
            title: text("Availability"),
            fields: [
                <Form.Field
                    clearable
                    control={HotelsDropDown}
                    placeholder={text('All')}
                    label={text('Hotel')}
                    key='HotelId'
                    onChange={setHotelIds}
                />,
                <Form.Field
                    control={RoomTypesDropDown}
                    clearable
                    search
                    placeholder={text('All')}
                    label={text("RoomType")}
                    key="RoomTypeIds"
                    spec={roomTypeSpec}
                />,
                <DatePicker
                    type='basic'
                    label={text('FromDate')}
                    key='FromDate'
                    clearable
                />,
                <DatePicker
                    type='basic'
                    label={text('ToDate')}
                    key='ToDate'
                    clearable
                />
            ],
            api: Availability.GetAvailability,
            spec: {
                includes: ["RoomType"]
            },
            setDoSearchRef: ref => doSearch.current = ref,
        },
        grid: {
            columns: [
                { name: 'HotelId', title: text('Hotel'), formatter: hotelFormatter },
                { name: 'Date', title: text('Date'), formatter: dateFormatter },
                { name: 'RoomTypeId', title: text('RoomType'), formatter: roomtypeFormatter },
                { name: 'GrossInventory', title: text('TotalRooms') },
                { name: 'Sold', title: text('NumberOfSoldRooms') },
                { name: 'OOOS', title: text('OutOfOrder') + "/" + text('OutOfService'), formatter: oooFormatter },
                { name: 'Available', title: text('AvailableRooms'), formatter: availableRoomsFormatter },
                { name: 'MaxOccupancy', title: text('PaxOccupancy'), formatter: maxOccupancyFormatter },
                { name: 'Occupancy', title: text('Occupancy'), formatter: occupancyFormatter },
                { name: 'Adults', title: text('Adults') },
                { name: 'Children', title: text('Children') },
                { name: 'Infants', title: text('Infants') },
            ],
            showFilter: true,
            paging: true,
            menu: [<Button key="create" style={{ position: "absolute" }} secondary onClick={() => setEdit(true)}>{text('Edit')}</Button>]
        }
    }

    return (
        <>
            <GridSearchTemplate options={gridOptions} />
            <EditMaxOccupancyPopup edit={edit} setEdit={setEdit} onSave={() => doSearch.current?.()} />
        </>
    )
}
export default AvailabilityPage;